"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Cubes;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
/**
 * This file is automatically GENERATED.
 * Manual changes might be lost - proceed with caution!
 *
 * 
 */

function Cubes(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    width: "1em",
    height: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "m10.5 15.429 3.548 1.837a1 1 0 0 0 .907.006l2.992-1.496a1 1 0 0 0 .553-.894v-2.764a1 1 0 0 0-.553-.894L14.5 9.5l-3.46 1.792a1 1 0 0 0-.54.888v3.249z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "m3.04 15.708 3.008 1.558a1 1 0 0 0 .907.006L10.5 15.5v-3.382a1 1 0 0 0-.553-.894L6.5 9.5l-3.46 1.792a1 1 0 0 0-.54.888v2.64a1 1 0 0 0 .54.888zM6.5 9.429l3.548 1.837a1 1 0 0 0 .907.006L14.5 9.5V6.118a1 1 0 0 0-.553-.894l-2.992-1.496a1 1 0 0 0-.907.006L7.04 5.292a1 1 0 0 0-.54.888v3.249z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "m6.846 5.673 3.207 1.603a1 1 0 0 0 .894 0L14.12 5.69h0m-3.274 5.983 3.207 1.603a1 1 0 0 0 .894 0l3.172-1.586h0m-15.273-.017 3.207 1.603a1 1 0 0 0 .894 0l3.172-1.586h0M10.5 7.5v4m4 2V17m-8-3.5V17"
      })]
    })
  });
}